<template>
  <div class="mode-free-troop">
    <div class="panel-title h-outer-border around-4 bw2 bz0 h-bg brown-2">
      <div class="label">英雄部队</div>
      <div class="panel-tools">
        <div class="btn h-title nowrap" data-title="清空所有部队" v-click-sound-button @click="handleClear">清空</div>
      </div>
    </div>

    <div class="troop-list">
      <TroopItem ref="troopItem"
                 :dataIndex="index"
                 :class="{ selected: selectIndex === index }"
                 v-for="(item, index) in troops"
                 :key="index">
      </TroopItem>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import TroopItem from './troop-item'

  const MAX_AMOUNT = 9999

  export default {
    data () {
      return {
        MAX_AMOUNT,
        troopCreatures: new Array(7).fill({}),
        selectedIndex: null
      }
    },

    props: {
      troopData: {
        type: Array,
        default () {
          return []
        }
      },

      allowMerge: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapState('freeConfig', [
        'selectIndex',
        'troops',
      ]),
    },

    methods: {
      handleClear () {
        this.$refs.troopItem.forEach((d) => {
          d.clear()
        })
      },
    },

    components: {
      TroopItem,
    }
  }
</script>

<style lang="stylus" scoped>
  .mode-free-troop
    user-select none

  .troop-list
    margin-top 5px
    display flex
    justify-content space-evenly

  .panel-title
    display flex
    align-items center
    margin-bottom 1px
    padding 2px 7px
    line-height 24px
    font-size 12px
    whiteText1()
    .label
      flex-grow 1
      letter-spacing 1px
      goldText()
    .info
      width 82px
      text-align right
      &:after
        width 150px

  .panel-tools
    position relative
    padding 0 10px
    display flex
    .btn
      padding 0 2px
      line-height 24px
      letter-spacing 1px
      user-select none
      color $colorGold
      opacity 0.75
      &:not(:last-child)
        margin-right 5px
      &:hover
        opacity 1
        color $colorGold
        cursor pointer
      &:active
        opacity 1
        color darken($colorGold, 15%)
</style>
